module.exports = __webpack_public_path__ + "static/media/landelijk.083b7d6c.jpg";